var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 30 30",
    height: "30px",
    id: "Layer_1",
    viewBox: "0 0 30 30",
    width: "30px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.65,7.575l-5.449-6.322l-1.079-1.252H9.246c-1.73,0-3.13,1.4-3.13,3.13v3.979h1.939L8.054,3.893   C8.058,2.92,8.839,2.133,9.81,2.133l11.017-0.01v5.218c0,1.943,1.569,3.517,3.513,3.517h3.814l-0.188,15.051   c-0.003,0.971-0.787,1.752-1.755,1.757L9.671,27.657c-0.885,0-1.597-0.866-1.603-1.938v-1.273H6.126v1.899   c0,1.909,1.279,3.462,2.85,3.462l17.798-0.005c1.729,0,3.131-1.407,3.131-3.134V9.032L28.65,7.575",
    fill: "#434440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.185,25.417H0V6.139h20.185V25.417 M1.938,23.476h16.306V8.08H1.938",
    fill: "#6B533B"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#6B533B",
    points: "3.077,10.931 16.986,10.931 16.986,12.918 3.077,12.918 3.077,10.931  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#6B533B",
    points: "3.078,14.906 16.988,14.906 16.988,16.893 3.078,16.893 3.078,14.906  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#6B533B",
    points: "3.078,18.88 11.026,18.88 11.026,20.868 3.078,20.868 3.078,18.88  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.1dc843159a14c09ba3aaf4c03dea16b3.svg";
export { ForwardRef as ReactComponent };